// globals
var classHelper = require("../helpers/class-helper.js");
var eventHelper = require("../helpers/event-helper.js");

// carousel element
const navigation = {
  settings: {
    menuopen: false,
    _nav: document.getElementById("nav"),
    _body: document.getElementsByTagName("body")[0],
    _burger: document.getElementById("burger"),
    _main: document.getElementById("main")
  },

  eventHandlers: function() {
    let _this = this;
    eventHelper.addEvent(_this.settings._burger, "click", function(e) {
      e.preventDefault();
      _this.toggleMenu();
    });
    eventHelper.addEvent(_this.settings._main, "click", function(e) {
      if (_this.settings.menuopen === true) {
        e.preventDefault();
        classHelper.removeClass(_this.settings._nav, "active");
        _this.settings.menuopen = false;
      }
    });
    let allanchors = document.querySelectorAll("#nav a");
    for (let i = 0; i < allanchors.length; i++) {
      eventHelper.addEvent(allanchors[i], "click", function(e) {
        if (e.target.hash === "#pricelist") {
          e.preventDefault();
          classHelper.removeClass(_this.settings._nav, "active");
          _this.settings.menuopen = false;
        }
      });
    }
  },

  toggleMenu: function() {
    this.settings.menuopen
      ? (this.settings.menuopen = true)
      : (this.settings.menuopen = false);

    classHelper.toggleClass(this.settings._nav, "active");
    classHelper.toggleClass(this.settings._body, "menu-open");
    // console.log(hkjkhj);
  },

  init: function() {
    // elements

    // init handlers
    this.eventHandlers();
  }
};

module.exports = navigation;



// WEBPACK FOOTER //
// ./modules/menu.js